import { useState } from "react";
import { Main } from "layouts";
import { Link } from "react-router-dom";
import { Button } from "expano-components";

import { MainList } from "components";

import ModalEditSpeditor from "./components/ModalEditSpeditor";
import ModalDeleteSpeditor from "./components/ModalDeleteSpeditor";

import { sort, filters } from "./const/data";
import ModalCreateSpeditor from "./components/ModalCreateSpeditor";

import { ReactComponent as UserIcon } from "icons/user.svg";

const default_state = { type: null, data: null };

const Speditors = () => {
  const [is_open_create_modal, setOpenCreateModal] = useState(false);
  const [speditor_edit_modal, setSpeditorEditModal] = useState(default_state);
  const [speditor_delete_modal, setSpeditorDeleteModal] = useState(null);

  const onClose = () => setSpeditorEditModal(default_state);

  return (
    <Main
      page={{
        name: "Zarządzanie spedytorami",
        icon: <UserIcon />,
        breadcrumbs: [{ name: "Zarządzanie spedytorami" }],
        buttons: (
          <>
            <Button
              type="add"
              text="Dodaj spedytora"
              onClick={() => setOpenCreateModal(true)}
            />
          </>
        ),
      }}
    >
      <MainList
        query_key="speditors"
        api_path="/speditors"
        title="Lista Spedytorów"
        sort_column="id"
        sort_direction="desc"
        sort={sort}
        filters={filters}
        renderActions={(item) => [
          {
            type: "edit",
            handleClick: () =>
              setSpeditorEditModal({
                type: "edit",
                data: item,
              }),
          },
          {
            type: "remove",
            handleClick: () =>
              setSpeditorDeleteModal({
                id: item.id,
                name: item.name,
              }),
          },
        ]}
        renderItem={({ id, name }) => (
          <>
            <td>{id}</td>
            <td>{name}</td>
          </>
        )}
      >
        {speditor_edit_modal?.type === "edit" && (
          <ModalEditSpeditor
            handleClose={onClose}
            {...speditor_edit_modal.data}
            initialValues={{
              name: speditor_edit_modal?.data?.name || "",
              street: speditor_edit_modal?.data?.street || "",
              city: speditor_edit_modal?.data?.city || "",
              zip_code: speditor_edit_modal?.data?.zip_code || "",
              city: speditor_edit_modal?.data?.city || "",
              country_code: speditor_edit_modal?.data?.country_code || "",
              is_virtual: speditor_edit_modal?.data?.is_virtual || "",
            }}
          />
        )}
        {speditor_delete_modal?.id && (
          <ModalDeleteSpeditor
            {...speditor_delete_modal}
            handleClose={() => setSpeditorDeleteModal(null)}
          />
        )}
        {is_open_create_modal && (
          <ModalCreateSpeditor handleClose={() => setOpenCreateModal(false)} />
        )}
      </MainList>
    </Main>
  );
};

export default Speditors;
